import * as React from 'react'

interface InEggParams {
  doRotateBy180Deg?: boolean
  colors: string[]
}

const EasterEggSvgIn = ({ doRotateBy180Deg = false, colors }: InEggParams): React.ReactElement => (
  <svg viewBox="0 0 64 64" width="32" height="32" transform={doRotateBy180Deg ? 'rotate(180)' : undefined}>
    <title>{'Easter Egg'}</title>
    <g style={{ isolation: 'isolate' }}>
      <g id="Layer_1">
        <path d="M16 36c0-15 7.2-26 16-26s16 11 16 26c0 11-7.2 20-16 20S16 47 16 36Z" fill={colors[0]} />
        <path
          d="M18.5 24l3.5 5 3.5-5 3.5 5 3.5-5 3.5 5 3.5-5 3.5 5 3.5-5"
          fill="none"
          stroke={colors[1]}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M17 31c0 0 5-1 15-1s15 1 15 1" fill="none" stroke={colors[2]} strokeWidth="3" strokeLinecap="round" />
        <circle cx="22" cy="37" r="2.2" fill={colors[3]} />
        <circle cx="29" cy="37" r="2.2" fill={colors[4]} />
        <circle cx="36" cy="37" r="2.2" fill={colors[3]} />
        <circle cx="43" cy="37" r="2.2" fill={colors[4]} />
        <path d="M17.5 43c0 0 5-1 14.5-1s14.5 1 14.5 1" fill="none" stroke={colors[1]} strokeWidth="3" strokeLinecap="round" />
        <path
          d="M20 49l3 4 3-4 3 4 3-4 3 4 3-4 3 4 3-4"
          fill="none"
          stroke={colors[2]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 36c0-15 7.2-26 16-26s16 11 16 26c0 11-7.2 20-16 20S16 47 16 36Z"
          fill="none"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M24 18c-2 3-3.5 7.5-3.5 12" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
      </g>
    </g>
  </svg>
)

export default EasterEggSvgIn
